module.exports = __webpack_public_path__ + "img/banner.5089c042.png";